import React from 'react';
import styled from 'styled-components';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import { SmartContainer } from '../Containers';
import { mimicButtonStyles } from './Button';
import { Theme } from '../Theme';

const BreadcrumbsStyles = styled(Breadcrumbs)``

const StyledCaptureCollabBreadcrumbs = styled(SmartContainer)`
    display: flex;
    /* opacity: 0.5; */
    margin-top:0.5em;
    > a {
       ${mimicButtonStyles}
       margin-right: 0.5em;
        text-decoration: none;
        border: 1px solid;
        padding: 0em 0.5em;
        font-size: 0.8em;
        text-align: center;
        color: ${Theme.colors.secondary};
        &:hover {
            /* background-color: rgba(0,0,0,0.25); */
        }
    }
`

export const StyledBreadcrumbs = ({ links }) => {

    const dispatch = useDispatch();
    const goTo = (e, path) => {
        e.preventDefault();
        dispatch(push(path))
    }


    return (
        <StyledCaptureCollabBreadcrumbs>
            {links.map(item => (<Link key={item.href} href={item.href} color="inherit" onClick={(e) => goTo(e, item.href)}>{item.title}</Link>))}
        </StyledCaptureCollabBreadcrumbs>
    )
}